import moment from "moment"
import { IThread } from "../../../../graphql/types/queries/conversation"

export const getDayText = (thread: IThread) => {
  const date = moment(thread.createdAt)
  // const diffHours = moment().diff(date, 'hours')
  if (date.isSame(moment(), 'day')) {
    return `Today`
  }
  if (date.isAfter(moment().add(-7, 'day'))) {
    return date.format('dddd')
  }

  if (moment().isSame(date, 'year')) {
    return date.format('MMM DD')
  } else {
    return date.format('MMM DD YYYY')
  }
}

export const getDateText = (thread: IThread) => {
  const date = moment(thread.createdAt)
  const diffHours = moment().diff(date, 'hours')
  if (diffHours < 1) {
    const diffMinutes = moment().diff(date, 'minutes')
    return `${diffMinutes} min${diffMinutes > 1 ? 's' : ''} ago`
  }

  if (diffHours < 24) {
    return `${diffHours} hr${diffHours > 1 ? 's' : ''} ago`
  }

  if (moment().isSame(date, 'year')) {
    return date.format('MMM DD, h:mma')
  } else {
    return date.format('MMM DD YYYY, h:mma')
  }
}